<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card >
      <v-card-title style="justify-content: center;">
        {{ $t('return.settings.deleteSettings') }}
      </v-card-title>
      <v-card-text class="pb-0 text-center">{{ $t('return.settings.confirmDelete') }}</v-card-text>
      <v-card-actions class="pa-0 mt-4">
        <v-btn
          color="primary"
          tile
          @click="validate()"
          style="width:50%"
        >
          {{ $t('return.settings.confirm') }}
        </v-btn>
        <v-btn
          color="secondary"
          class="ml-0"
          tile
          @click="close()"
          style="width:50%"
        >
          {{ $t('return.settings.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDeleteReturnSettings',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    validate () {
      this.$emit('confirm')
    },
    close () {
      this.$emit('close')
    },
  },
}
</script>
